<template>
	<div>
		<div class="attend-card-wrapper" @click="handleClick">
			<div
				v-if="user.userFlag"
				:style="{ backgroundColor: user.userFlag.flag_bg_color }"
				class="attend-card__user-flag"
			>
				<span
					:style="{
						backgroundColor: user.userFlag.flag_bg_color,
						color: user.userFlag.flag_txt_color,
					}"
				>
					{{ user.userFlag.flag_name }}
					<span :style="{ backgroundColor: user.userFlag.flag_bg_color }"></span>
				</span>
			</div>
			<Avatar class="mr-4 post-preview-card__avatar" :size="50" :avatar="user.user_logo" />

			<div class="d-flex flex-column justify-space-between mt-1">
				<div class="attend-card-title">
					{{ user.visible_username }}
				</div>
				<div class="attend-card-description mt-1">
					{{ user.second_profile_row }}
				</div>
				<div class="attend-card-description mt-1">
					{{ user.third_profile_row }}
				</div>
				<div
					class="attend-card-loc mt-1 d-flex align-center"
					v-if="user.location_profile_row"
				>
					<Icon type="pin" color="var(--location-color)" :size="16" :pr="4" />
					{{ user.location_profile_row }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'
import Dwh from '@/mixins/Dwh'

Vue.use(VueScrollTo)

export default {
	name: 'AttendCard',
	mixins: [Dwh],
	components: {
		Avatar,
	},
	props: {
		user: {
			type: Object,
			default: () => ({}),
		},
		event: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		handleClick() {
			this.sendTrigger({
				category: 'Attendees',
				action: 'click_attendee_profile_event',
				module: 'Events',
        title: this.user.visible_username,
        id2: this.$route.params.id,
        id1: this.user.user_id,
			})
		},
	},
}
</script>

<style lang="scss">
.attend-card {
	&-wrapper {
		display: flex;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 8px;
		position: relative;
		padding: 12px;
		margin-top: 8px;
		min-height: 105px;
		align-items: center;
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}

	&-title {
		color: var(--username-category-title);
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;

		@media (max-width: 480px) {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
		}
	}

	&-loc {
		display: flex;
		font-size: 13px;
		font-family: Inter, sans-serif;
		font-weight: 500;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--location-color) !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
	}

	&-description {
		color: var(--company-position-large);
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
	}

	&__user-flag {
		text-align: right;
		position: absolute;
		border-radius: 12px;
		top: 0;
		right: 0;

		span {
			z-index: 0;
			position: relative;
			background: var(--accent-color);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			border-top-right-radius: 8px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		// Start
		span {
			span {
				z-index: -1;
				content: '';
				position: absolute;
				left: -17%;
				top: 0;
				height: 100%;
				width: 100%;
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}
}
</style>
